import I18n from 'I18n';
import UISection from 'UIComponents/section/UISection';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ErrorAlert from './ErrorAlert';
import HubspotAuthForm from './HubspotAuthForm';
import CodeEntryForm from '../CodeEntryForm';
import NewCodeAlert from '../NewCodeSentAlert';
import SmsCodeRetry from '../SmsCodeRetry';
import TestIds from '../../constants/testIDs';
import TwoFactorAuthMethod from '../../constants/twoFactorAuthMethod';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TwoFactorForm = ({
  currentAuthMethod,
  formOnSubmit,
  codeLength,
  formOnChange,
  code,
  canSubmit,
  openTwoFactorRecovery,
  currentError,
  setCurrentError,
  codeSentKey,
  email,
  currentObfuscatedInfo,
  setCodeSentKey,
  retryCode
}) => {
  return currentAuthMethod === TwoFactorAuthMethod.HUBSPOT_AUTHENTICATOR ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx("br", {})
    }), /*#__PURE__*/_jsx(UIAccordionItem, {
      title: I18n.text('reAuth.mobileAuth.noLoginPrompt'),
      children: /*#__PURE__*/_jsx(HubspotAuthForm, {
        formOnSubmit: formOnSubmit,
        codeLength: codeLength,
        formOnChange: formOnChange,
        code: code,
        canSubmit: canSubmit,
        openTwoFactorRecovery: openTwoFactorRecovery
      })
    }), currentError ? /*#__PURE__*/_jsx(ErrorAlert, {
      setTwoFactorError: setCurrentError,
      currentError: currentError
    }) : null]
  }) : /*#__PURE__*/_jsxs(UISection, {
    children: [/*#__PURE__*/_jsxs("form", {
      onSubmit: formOnSubmit,
      children: [/*#__PURE__*/_jsx(CodeEntryForm, {
        codeLength: codeLength,
        onChange: formOnChange,
        code: code
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        disabled: !canSubmit,
        type: "submit",
        "data-test-id": TestIds.CODE_SUBMIT_BUTTON,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reAuth.codeForm.verify"
        })
      })]
    }), currentAuthMethod === 'SMS' && /*#__PURE__*/_jsx(SmsCodeRetry, {
      retryCode: retryCode
    }), codeSentKey && /*#__PURE__*/_jsx(NewCodeAlert, {
      keyWord: codeSentKey,
      hideAlert: () => setCodeSentKey(undefined),
      obfuscatedInfo: email || currentObfuscatedInfo
    }), currentError ? /*#__PURE__*/_jsx(ErrorAlert, {
      setTwoFactorError: setCurrentError,
      currentError: currentError
    }) : null]
  });
};
export default TwoFactorForm;